import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { I as inputCheckboxInvalid, J as inputCheckboxCheckedFocused, K as inputCheckboxFocused, L as inputCheckboxChecked, M as inputCheckbox, l as label } from './parts.js';
import { F as FormControlHelpText } from './form-control-help-text2.js';
import { F as FormControlErrorText } from './form-control-error-text.js';
import './details.js';

const CheckboxInput = /*@__PURE__*/ proxyCustomElement(class CheckboxInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.handleFormControlInput = (event) => {
            event.preventDefault();
            const target = event.target;
            const name = target.getAttribute('name');
            this.inputHandler(name, target.checked);
            this.formControlInput.emit({ name, value: target.value });
        };
        this.updateInput = (newValue) => {
            this.checkboxElement.checked = newValue;
        };
        this.isFocused = false;
        this.label = undefined;
        this.name = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.checked = undefined;
        this.inputHandler = undefined;
        this.disabled = undefined;
    }
    get part() {
        if (this.errorText) {
            return inputCheckboxInvalid;
        }
        if (this.isFocused && this.checked) {
            return inputCheckboxCheckedFocused;
        }
        if (this.isFocused) {
            return inputCheckboxFocused;
        }
        if (this.checked) {
            return inputCheckboxChecked;
        }
        return inputCheckbox;
    }
    render() {
        return (h(Host, { key: '6ea0ca6e03a956c5c11e6b6b67802a8344e6f3d8' }, h("div", { key: '87a7a3e9d34992d992464b8d6fe8ba712ff32865', class: 'form-group d-flex flex-column' }, h("div", { key: 'e3da6c3971c74163e914f53c9b5a480dbac2759b', class: "form-check" }, h("input", { key: '01af0856f7e2ad919790a7ec8896cb06e3329452', ref: el => (this.checkboxElement = el), type: "checkbox", id: this.name, name: this.name, onFocus: () => this.isFocused = true, onBlur: () => {
                this.isFocused = false;
                this.formControlBlur.emit();
            }, onInput: this.handleFormControlInput, part: this.part, class: this.errorText ? 'form-check-input is-invalid' : 'form-check-input', disabled: this.disabled, checked: this.checked }), h("label", { key: '069d3ee70d0cc1c48092407055e8666a1156e7c6', class: "form-check-label", htmlFor: this.name, part: label }, this.label)), h(FormControlHelpText, { key: 'bbc6d2e5fdef899236c07738bfa15b51b02c6912', helpText: this.helpText, name: this.name }), h(FormControlErrorText, { key: '456e4ad15ab35e4b68102abfcd058e2d16ac0232', errorText: this.errorText, name: this.name }))));
    }
}, [0, "form-control-checkbox", {
        "label": [1],
        "name": [8],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "checked": [4],
        "inputHandler": [16],
        "disabled": [4],
        "isFocused": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-checkbox"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-checkbox":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CheckboxInput);
            }
            break;
    } });
}
defineCustomElement();

export { CheckboxInput as C, defineCustomElement as d };
